export interface TituloReceberOptionsActions {
    canEdit: boolean;
    canVisualizar: boolean;
    // Integração ERP
    canImportOneErp_v1: boolean;
    canImportOneErp: boolean;
}


export class TituloReceberOptions implements TituloReceberOptionsActions {
    canEdit: boolean;
    canVisualizar: boolean;
    canImportOneErp_v1: boolean;
    canImportOneErp: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return   this.canEdit ||
                this.canVisualizar ||
                this.hasAnyOptionIntegracaoErp();
    }

    hasAnyOptionIntegracaoErp() {
        return this.canImportOneErp_v1 || this.canImportOneErp;
    }
}
